import { Alert, Button, Flex, SegmentedControl } from "@mantine/core";
import { IError, ILabelAndCount } from "@mctypes/global.types";
import React, { useEffect } from "react";
import { ConfirmDialog } from "../../../../components";
import { useDeleteAllErrorsMutation } from "../../admin/errorRTK";
import { doDeleteError, doGetErrors } from "../../admin/restQueries";
import FlatErrorTable from "./FlatErrorTable";
import GroupErrorTable from "./GroupErrorTable";
import { groupAndCountErrors } from "./errorUtils";

const ErrorPage: React.FC = () => {
  const [errors, setErrors] = React.useState<IError[] | null>(null);
  const [groupedByRouterErrorMessage, setGroupedByRouterErrorMessage] = React.useState<ILabelAndCount[] | null>(null);
  const [isGroupMode, setIsGroupedMode] = React.useState<boolean>(false);

  useEffect(() => {
    fetchAndSetErrors();
  }, []);

  const fetchAndSetErrors = async () => {
    const _errors = await doGetErrors();
    const grouped = groupAndCountErrors(_errors, "routeMessage");
    setGroupedByRouterErrorMessage(grouped);
    setErrors(_errors);
  };

  const deleteError = async (_id: string) => {
    await doDeleteError(_id);
    await fetchAndSetErrors();
  };

  const [deleteAllErrors, { isError: deleteAllErrorsError, isLoading: isDeletingAll }] = useDeleteAllErrorsMutation();

  return (
    <>
      <Flex p="sm" justify="space-between" align="center">
        <SegmentedControl
          value={isGroupMode ? "group" : "all"}
          onChange={(v) => setIsGroupedMode(v === "group")}
          data={[
            { label: "Alle errors", value: "all" },
            { label: "Grupperat", value: "group" },
          ]}
        />
        <ConfirmDialog
          title="Bekreft sletting"
          message="Er du sikker på at du vil slette alle errors?"
          confirmCb={async () => {
            await deleteAllErrors();
            await fetchAndSetErrors();
          }}
        >
          <Button color="red" variant="filled" loading={isDeletingAll}>
            Slett alle
          </Button>
        </ConfirmDialog>
      </Flex>

      {errors != null && !isGroupMode && <FlatErrorTable errors={errors} onDeleteError={deleteError} />}

      {errors != null && isGroupMode && (
        <GroupErrorTable
          labelAndCounts={groupedByRouterErrorMessage ?? []}
          groupProp="routeMessage"
          deleteError={deleteError}
        />
      )}

      {deleteAllErrorsError && (
        <Alert color="red" title="Feil" style={{ margin: 8 }}>
          Misslyckades med att ta bort alla errors. Försök igjen.
        </Alert>
      )}
    </>
  );
};

export default ErrorPage;
